import { useAccountEntitlements } from "@/entitlements/queries/useAccountEntitlements";
import { consentManagementIntegrations } from "./consentManagement";

const consentManagerEntitlementKeys = new Set(
  Object.values(consentManagementIntegrations).map(
    (integration) => integration.entitlementKey,
  ),
);

export function useHasConsentManagerEntitlement(): {
  loading: boolean;
  isError: boolean;
  hasEntitlement: boolean;
} {
  const { data, isLoading, isError } = useAccountEntitlements();

  return {
    loading: isLoading,
    isError,
    hasEntitlement:
      data?.account_access?.some((access) =>
        consentManagerEntitlementKeys.has(access.entitlement_key),
      ) ?? false,
  };
}

/**
 * Narrower than `useHasConsentManagerEntitlement`, which is true for any vendor.
 * Callers that offer to sell the Freshpaint Consent Manager specifically need
 * this one: an account entitled to OneTrust alone should still be offered it.
 */
export function useHasFreshpaintConsentManagerEntitlement(): {
  loading: boolean;
  isError: boolean;
  hasEntitlement: boolean;
} {
  const { data, isLoading, isError } = useAccountEntitlements();

  return {
    loading: isLoading,
    isError,
    hasEntitlement:
      data?.account_access?.some(
        (access) =>
          access.entitlement_key ===
          consentManagementIntegrations.freshpaint.entitlementKey,
      ) ?? false,
  };
}
